@if (textColor && backgroundColor) {
  <span
    class="notranslate mb-0.5 inline-block rounded-xm px-2 font-base text-xs font-bold leading-5"
    [style.color]="textColor | contentBuilderColor: '#FFFFFF'"
    [style.backgroundColor]="backgroundColor | contentBuilderColor: 'primary-600'"
  >
    {{ quantity }}×
  </span>
} @else {
  <span
    class="notranslate mb-0.5 inline-block rounded-xm px-2 font-base text-xs font-bold leading-5"
    [ngClass]="
      dark ? 'text-neutral-700 bg-neutral-200 lg:bg-neutral-300' : 'text-white bg-primary-600'
    "
  >
    {{ quantity }}×
  </span>
}
